
<template>

  <div class="atividades-sinistros ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->
              <!-- -->
              <b-col cols="4">
                <label for="select-empresa-cor">Empresa</label> 
                <multiselect  id="selecao-empresa-cor-ind"  v-model="empresaf" 
                  :options="empresasf" 
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true"                              
                  @close="loadFiliais()" 
                  :preserve-search="true" placeholder="Selecione a empresa" label="empresa" track-by="empresa" name="empresa"
              >                  
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Empresa selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="3">
                <label for="select-filial_cor">Filial</label>
                <multiselect id="selecao-filial-coe-ind"  v-model="valor_filial"
                  :options="filiaisf" 
                  :multiple="true"                           
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a filial" label="filial" track-by="filial" name="filial"
                  :preselect-first="true">
                
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Filial selecionada</span></template>
                </multiselect> 
              </b-col>


              

              <b-col cols="2">
                <div>                            
                  <label  for="datepicker-placeholder">Data inicial</label>                        
                  <b-form-datepicker id="dt_sol_inicial"  required  v-model="dt_inicial"  placeholder="Data inicial " locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                </div>                     
              </b-col>

              <b-col cols="2">
                <div>                            
                  <label  for="datepicker-placeholder">Data final</label>
                  <b-form-datepicker id="dt_sol_final"  required  v-model="dt_final" placeholder="Data do final" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker> 

                </div>                     
              </b-col>

              
            <b-col cols=1 class="mt-4">
                    
          <b-button size="sm" id="btn-pesquisar" variant="success" block class="mr-2 mt-1 "  @click="loadKpiDiaRequisicao(),loadKpiSolicitante(),loadKpiFilial(),loadKpiMaterial(),loadKpiRequisicaoQtd(),loadKpiCarro()">
              <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Filtrar gráfico
          </b-button>
              </b-col>

              <LoadingModal v-if="isLoading" />

              
             
          </b-row>
    </b-form>   



          <!--  <b-card-group class="ml-3 mt-3 mb-3" deck>    -->
        <b-card-group class="ml-3 mt-3 mb-3 d-flex justify-content-center" deck>

              <b-card            
                class="ml-2"
                style="width: 33rem;"
                border-variant="primary"
                header="QUANTIDADE DE ITENS NO PERÍODO"
                header-bg-variant="primary"
                header-text-variant="white"
                align="center"

              >
                <b-card-text> 
                  <h2>                    

                      {{ kpiqtds.length  }}

                      
                  
                  </h2>
                </b-card-text>
              </b-card>   


        </b-card-group> 

    
    <!-- Painel -->
    <!-- Painel -->
    <!-- Painel -->

    <template>      
      <div >
        
        <!-- diário  -->
        <b-row>
  

          <b-col cols="9" class="mt-4" id="grafdia">            
            <apexcharts             
            ref="chartdia"
            height="400" 
            :options="graficoDia" 
            :series="seriesdia"
            >
            </apexcharts>
          </b-col>

          <b-col cols="3">
            <apexcharts
            ref="chartportalusuarioxfuncionario" 
            height="400" 
            :options="graficoPortalPercentual" 
            :series=" kpiqtds.length<=0 ? [0.00] :[ (kpiqtds.filter( s => s.venda_perdida != true).length /  kpiqtds.length * 100).toFixed(2) ] "
            ></apexcharts>
          </b-col>


        </b-row>

        

        <!-- acumulado  -->
        <b-row>
          
          <!-- acumulado  PROGRAMA
           -->
          <b-col cols="3">
            <apexcharts
            ref="chartprograma" 
            height="400" 
            :options="graficoPrograma" 
            :series="seriesprograma"
            ></apexcharts>
          </b-col>

          <!-- acumulado  função -->
          <b-col cols="3">
            <apexcharts 
            ref="chartfuncao"
            height="400" :options="graficoMaterial" 
            :series="seriesfuncao"></apexcharts>
          </b-col>

   


          <!-- acumulado  carro -->
          <b-col cols="3">
            <apexcharts 
            ref="chartfuncionario"
            height="400" :options="graficoFuncionario" 
            :series="seriesfuncionario"></apexcharts>
          </b-col>

                    <!-- acumulado  FILIAL -->
          <b-col cols="3">
            <apexcharts 
              ref="chart"
              height="400" 
              :options="graficoPizzaFilial"   
              :series ="graficoPizzaFilial.series"     
              
            >
            </apexcharts> 
            
                       
          </b-col>

        </b-row>

      </div>      
    </template>

    <!-- Painel -->
    <!-- Painel -->
    <!-- Painel -->
    


  </div>  

</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment, { now } from 'moment'
import { mapState } from 'vuex' 
import VueApexCharts from 'vue-apexcharts'
import { onBeforeUpdate } from 'vue'
import LoadingModal from '../utilitarios/LoadingModal'


export default {  
  name: 'SolicitacaoPainel',

  components: {
    apexcharts: VueApexCharts,
    Multiselect,LoadingModal
  },
    computed : { ... mapState (['user'],),

    } ,

    data: function() {    

        return {

  isLoading: false,

  /* diario */
  graficoDia: {
    chart: {
              id: 'bar-dia',
              type: 'area',
              height: 350,                          
              foreColor:"black",
              toolbar: {
                show: false                
              },
              
    },
    xaxis: {  
            categories:[], 
              tickPlacement: 'of'            
    }, 

   dataLabels: {
          style: {
            fontSize: '18px', // Defina o tamanho da fonte dos valores nas barras
          },
          enabled: true,
    }, 
    
    
    title: {
      text: 'Itens requisitados diários',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    },
    
  },



  
/* PROGRAMA    */
  graficoPrograma: {
    chart: {
              id: 'bar-programa',
              type: 'bar',
              height: 350,            
              foreColor:"black",
              toolbar: {
                show: false
              },
    },
    plotOptions: {
      bar: {
        horizontal: true
      }
    },
    xaxis: {  
            categories:[], 
              tickPlacement: 'of'            
    }, 
    
        dataLabels: {
          style: {
            fontSize: '18px', // Defina o tamanho da fonte dos valores nas barras
          },
          enabled: true,
    }, 

    title: {
      text: 'TOP 20 CARROS',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },


  
/* Função    */
  graficoMaterial: {
    chart: {
              id: 'bar-material',
              type: 'bar',
              height: 350,            
              foreColor:"black",
              toolbar: {
                show: false
              },
    },
    plotOptions: {
      bar: {
        horizontal: true
      }
    },
    xaxis: {  
            categories:[], 
              tickPlacement: 'of'            
    },
    
        dataLabels: {
          style: {
            fontSize: '18px', // Defina o tamanho da fonte dos valores nas barras
          },
          enabled: true,
    }, 

    title: {
      text: 'TOP 20 MATERIAIS',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },

  


  /* funcionario */
  graficoFuncionario: {
    chart: {
              id: 'bar-departamento',
              type: 'bar',
              height: 350, 
              foreColor:"black",
              toolbar: {
                show: false
              },
              
    },
    plotOptions: {
      bar: {        
        horizontal: true,
       // isFunnel: true,        
      }
    },
    xaxis: {  
      labels: {      
        maxWidth: 400,  // Define uma largura máxima para os rótulos        
      },    

      categories:[], 
      tickPlacement: 'of'            
    },    

    dataLabels: {
          style: {
            fontSize: '18px', // Defina o tamanho da fonte dos valores nas barras
          },
          enabled: true,
    }, 
    title: {
      text: 'TOP 20 SOLICITANTES',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },

    /* filial */  
  graficoPizzaFilial: {
          chart: {
            id: 'pizza-filial',             
            type: 'pie', 
            height: 350,                                      
            foreColor:"black",                         
                          //fontFamily: 'Arial, sans-serif', // Defina a fonte desejada
              fontSize: '122px', // Tamanho da fonte      
          },
          labels: [],
          legend: {
            show: true,             
            position: 'bottom',
          },
              dataLabels: {
          style: {
            fontSize: '18px', // Defina o tamanho da fonte dos valores nas barras
          },
          enabled: true,
    }, 

          title: {
            text: 'FILIAIS',
            align: 'center',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '22px',
              fontWeight:  'bold',
              color:  '#263238'
            },
          }
  },


  ///////////////////  venda perdida
      /* Percentual */
    graficoPortalPercentual: {
      chart: {
                id: 'RadialBar-percentual',
                type: 'radialBar',
                height: 350,            
              
                foreColor:"black",
                toolbar: {
                  show: false
                },
                colors: ["#20E647"],
      },
        plotOptions: {
    radialBar: {
      hollow: {
        margin: 0,
        size: "70%",
        background: "#293450"
      },
      track: {
        dropShadow: {
          enabled: true,
          top: 2,
          left: 0,
          blur: 4,
          opacity: 0.15
        }
      },
      dataLabels: {
        name: {
          offsetY: -10,
          color: "#fff",
          fontSize: "13px"
        },
        value: {
          color: "#fff",
          fontSize: "30px",
          show: true
        }
      }
    }
  },
  fill: {
    type: "gradient",
    gradient: {
      shade: "dark",
      type: "vertical",
      gradientToColors: ["#87D4F9"],
      stops: [0, 100]
    }
  },
  stroke: {
    lineCap: "round"
  },
  labels: ["ATENDIMENTO"]

    },


  empresaf:'', 
  empresasf:[],   // [] lista       
  filialf:[],   
  filiaisf:[],   // [] lista   
  valor_filial:[],
  tipo:'',
  tipos:[],


/* objetos */

  kpiqtds:[],
  kpitipos:[],  
  kpidias:[],  
  kpidiastotal:[],            // calcular a média de dias
  kpiprograma:[] ,
  kpifuncionario:[],
  kpifiliais:[],
  kpifuncao:[],
  seriestipo:[],
  seriesdia:[],
  seriesprograma:[],
  seriesfuncionario:[],
  seriesfuncao:[],
  seriesPizzaFilial:[] ,

  dt_inicial: '',
  dt_final: '',  

  sinistros:[],
  seriesPizzaFilial:[] ,
  seriesColunaDia:[],  
  seriesfilial:[],  
  value_empresa:[],// [this.empresas],            
  permissoes:[],
  permissao:{},

  mode: 'save',
  carregando: false,
  atualizando: false,   
  value_filial:[],            
  value_status:[],     

        }        
    },

    

    methods: {    
      
      loadEmpresas() {
            let corpo = {    
                "empresa_id": `${this.user.id_grupo_empresa}`,                                            
            };

          const url = `${baseApiUrl}/jb/controle/empresa`
          axios.post(url,corpo).then(res => {
            this.empresasf = res.data.map(emp => {              
              return { id_empresa: emp.id_empresa, empresa: emp.empresa }
            })
          })
      },  
      
      loadFiliais() {
            let corpo = {    
                "empresa_id": `${this.user.id_grupo_empresa}`,                                            
            };
          const url = `${baseApiUrl}/jb/controle/empresa/filial`
          axios.post(url,corpo).then(res => {
            this.filiaisf = res.data.map(filial => {              
              return { filial_id: filial.filial_id, filial: filial.filial }        
            })
          })
      },


      /// qtd solicitações card kpi
      async loadKpiRequisicaoQtd() {
            let corpo = {    
               "empresa_id": `${[this.user.id_empresa]}`,                            
               "filial_id": `${[this.valor_filial.map(f => f.filial_id)]}`,                                                      
                "dt_inicial": `${this.dt_inicial}`,                                            
                "dt_final": `${this.dt_final}`,          
                "tipo":'ESTOQUESOLICITACAORESUMO'
            };
          const url = await `${baseApiUrl}/jb/indicadores/kpiEstoqueSolicitacao`
          axios.post(url,corpo)
            .then(res => {              
            this.kpiqtds = res.data             
            })
            .catch(showError)
    },


      /// filtros por dia (PERIODO) 10/07/2024
      async loadKpiDiaRequisicao() {
        let corpo = {    
               "empresa_id": `${[this.user.id_empresa]}`,                            
               "filial_id": `${[this.valor_filial.map(f => f.filial_id)]}`,                                                      
                "dt_inicial": `${this.dt_inicial}`,                                            
                "dt_final": `${this.dt_final}`,          
                "tipo":'ESTOQUESOLICITACAODIA'
        };
                const url = await `${baseApiUrl}/jb/indicadores/kpiEstoqueSolicitacao`
                axios.post(url,corpo)
                  .then(res => {              
                  this.kpidias = res.data        
                  this.updateChartDataDia()            
                  })
                  .catch(showError)
          },

    

    async updateChartDataDia() {

      this.seriesdia = [{
        name: 'Qtds',
        data: this.kpidias.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartdia.updateOptions({ xaxis:{
        //categories: this.kpidias.map(item => moment(item.dt_visualizacao).format('DD'))        
        //categories: this.kpidias.map(item => moment(item.dt_visualizacao).locale('PT-BR').format('DD/MM/YYYY'))        
        categories: this.kpidias.map(dt => moment(dt.dt_lancamento).locale('PT-BR').format('DD/MM'))
      }  });       
    },


    
    /// filtros por solicitante 19/02/2024
    async loadKpiSolicitante() {
          let corpo = {    
               "empresa_id": `${[this.user.id_empresa]}`,                            
               "filial_id": `${[this.valor_filial.map(f => f.filial_id)]}`,                                                      
                "dt_inicial": `${this.dt_inicial}`,                                            
                "dt_final": `${this.dt_final}`,          
                "tipo":'ESTOQUESOLICITACAOSOLICITANTE'
        };
          const url = await `${baseApiUrl}/jb/indicadores/kpiEstoqueSolicitacao`
          axios.post(url,corpo)
            .then(res => {              
            this.kpifuncionario = res.data 
            this.updateChartDataFuncionario();               
            })
            .catch(showError)
    },
    
    async updateChartDataFuncionario() {
      this.seriesfuncionario = [{
        name: 'Qtd',
        data: this.kpifuncionario.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartfuncionario.updateOptions({ xaxis:{
        categories: this.kpifuncionario.map(r => r.solicitante_re)
      }  });       
    },



    /// filtros por operador 19/09/2023
      async loadKpiCarro() {
            let corpo = {    
                    "empresa_id": `${[this.user.id_empresa]}`,                            
               "filial_id": `${[this.valor_filial.map(f => f.filial_id)]}`,                                                      
                "dt_inicial": `${this.dt_inicial}`,                                            
                "dt_final": `${this.dt_final}`,          
                "tipo":'ESTOQUESOLICITACAOCARRO'                                                                                     
            };
          const url = await `${baseApiUrl}/jb/indicadores/kpiEstoqueSolicitacao`
          axios.post(url,corpo)
            .then(res => {              
            this.kpiprograma = res.data 
            this.updateChartDataprograma();               
            })
            .catch(showError)
    },
    
    async updateChartDataprograma() {
      this.seriesprograma = [{
        name: 'Qtd carros',
        data: this.kpiprograma.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartprograma.updateOptions({ xaxis:{
        categories: this.kpiprograma.map(r => r.carro)
      }  });       
    },

        /// filtros por função 06/12/2023 as 15:45h
      async loadKpiMaterial() {
             let corpo = {    
                "empresa_id": `${[this.user.id_empresa]}`,                            
               "filial_id": `${[this.valor_filial.map(f => f.filial_id)]}`,                                                      
                "dt_inicial": `${this.dt_inicial}`,                                            
                "dt_final": `${this.dt_final}`,          
                "tipo":'ESTOQUESOLICITACAOMATERIAL'                                                                                     
            };
          const url = await `${baseApiUrl}/jb/indicadores/kpiEstoqueSolicitacao`
          axios.post(url,corpo)
            .then(res => {              
            this.kpifuncao = res.data 
            this.updateChartDataFuncao();               
            })
            .catch(showError)
    },
    
    async updateChartDataFuncao() {
      this.seriesfuncao = [{
        name: 'Qtd itens por material',
        data: this.kpifuncao.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartfuncao.updateOptions({ xaxis:{
        categories: this.kpifuncao.map(r => r.material)
      }  });       
    },


    
      /// filtros por filial  getKpiInformaticaFilial
      async loadKpiFilial() {
        this.isLoading = true; // Ative o indicador de carregamento  
          let corpo = {    
                "empresa_id": `${[this.user.id_empresa]}`,                            
               "filial_id": `${[this.valor_filial.map(f => f.filial_id)]}`,                                                      
                "dt_inicial": `${this.dt_inicial}`,                                            
                "dt_final": `${this.dt_final}`,          
                "tipo":'ESTOQUESOLICITACAOFILIAL'                                                                                     
            };
          const url = `${baseApiUrl}/jb/indicadores/kpiEstoqueSolicitacao`
          axios.post(url,corpo)
            .then(res => {
              this.kpifiliais = res.data                
              this.updateChartDataFilial();   
              this.isLoading = false; // Desative o indicador de carregamento           
            })
            .catch(showError)
      },

      async updateChartDataFilial() {                                                      
            this.graficoPizzaFilial.series = this.kpifiliais.map(item => parseInt(item.qtd));
            this.atualizarLabels()
      },

      async atualizarLabels() {
        this.graficoPizzaFilial.labels = await this.kpifiliais.map(item => item.filial_id);        
        this.$refs.chart.updateOptions({ labels: this.graficoPizzaFilial.labels });              
      },












    },




    mounted(){
      this.loadEmpresas()      
      /*
      this.loadKpiDiaRequisicao()
      this.loadKpiSolicitante()        
      this.loadKpiFilial()
      this.loadKpiMaterial()   
      this.loadKpiRequisicaoQtd()        
      this.loadKpiCarro()      
      */
    },

    
   
  



}


</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>





</style>